// The membership app's primary button, so the flow's main actions look the same on both sides
// of the paywall. React-Membership: ButtonModern on cwb-react's Button, theme palette.button
// (normal #0F9BF0, hover #0892E5, pressed #0584D7) and its disabled look (grey text on grey,
// normal weight), 4px corners, a 14px bold label. Only the look: each button keeps its own
// width, height and spacing.

import { css } from "styled-components";

export const MEMBERSHIP_BLUE = {
  normal: "#0f9bf0",
  hover: "#0892e5",
  pressed: "#0584d7",
};

// cwb-react theme brand.darkBlue and grey[1]: the secondary's outline and hover.
export const MEMBERSHIP_DARK_BLUE = "#0a1f44";
const DARK_BLUE = MEMBERSHIP_DARK_BLUE;
const HOVER_GREY = "#f8f9fb";

const greyed = css`
  color: #8a94a6;
  background-color: #f1f2f4;
  border-color: #f1f2f4;
  font-weight: 400;
`;

export const membershipPrimary = css`
  background-color: ${MEMBERSHIP_BLUE.normal};
  border: 1px solid ${MEMBERSHIP_BLUE.normal};
  color: #ffffff;
  border-radius: 4px;
  font-size: 14px;
  font-weight: 700;
  line-height: 19px;
  cursor: pointer;

  &:hover {
    background-color: ${MEMBERSHIP_BLUE.hover};
    border-color: ${MEMBERSHIP_BLUE.hover};
  }

  &:active {
    background-color: ${MEMBERSHIP_BLUE.pressed};
    border-color: ${MEMBERSHIP_BLUE.pressed};
  }

  &:disabled,
  &:disabled:hover {
    ${greyed}
    opacity: 1;
    cursor: default;
  }
`;

// The membership app's secondary (ButtonModern variant="secondary"): dark blue outline and label on
// white, a light grey on hover, the primary's corners and label, the same disabled look.
export const membershipSecondary = css`
  background-color: #ffffff;
  border: 1px solid ${DARK_BLUE};
  color: ${DARK_BLUE};
  border-radius: 4px;
  font-size: 14px;
  font-weight: 700;
  line-height: 19px;
  cursor: pointer;

  &:hover,
  &:active {
    background-color: ${HOVER_GREY};
    color: ${DARK_BLUE};
    text-decoration: none;
  }

  &:disabled,
  &:disabled:hover {
    ${greyed}
    opacity: 1;
    cursor: default;
  }
`;

// Greyed like a disabled button, but still clickable: step 2's Continue before the photo is
// in opens the "no photo" sheet.
export const membershipPrimaryNotReady = css`
  &,
  &:hover,
  &:active {
    ${greyed}
  }
`;
